<div class="lv-login-box">
  <div class="lv-login-box__header"></div>
  <div class="lv-login-box__content">
    <div class="lv-login-box__title" translate>password-reset-success.title</div>
    <div class="success-message" translate>password-reset-success.success-message</div>
    <div class="message" translate>password-reset-success.description</div>
    <a routerLink="/auth/sign_in" class="button" translate>password-reset-success.button</a>
  </div>
</div>

<lv-copyright></lv-copyright>
